import React from "react";
import { Button } from "@mui/material";
import * as Icon from "../../../../../../assets/iconsSVG";
import * as Styles from "./styles";

interface Props {
  onClose: () => void;
  openOpportunityForm: () => void;
  onButtonStateChange: (newState: boolean) => void;
}

const Header: React.FC<Props> = (props) => {
  const [button, setButton] = React.useState(true);

  const handleButtonClick = (newState: boolean) => {
    setButton(newState);
    props.onButtonStateChange(newState);
  };

  return (
    <Styles.Container>
      <Styles.RowSpace>
        <Styles.Row>
          <Styles.StyledButton
            active={button}
            onClick={() => handleButtonClick(true)}
          >
            <Styles.Title active={button}>Espelho de vendas</Styles.Title>
          </Styles.StyledButton>
          <Styles.StyledButton
            active={!button}
            onClick={() => handleButtonClick(false)}
          >
            <Styles.Title active={!button}>Resumo</Styles.Title>
          </Styles.StyledButton>
          {/* <Icon.OportunityIcon />
          <Styles.Title>Espelho de vendas</Styles.Title> */}
        </Styles.Row>
        <Styles.Button
          onClick={() => {
            props?.onClose();
            props?.openOpportunityForm();
          }}
        >
          <Icon.CloseIcon />
        </Styles.Button>
      </Styles.RowSpace>
    </Styles.Container>
  );
};

export default Header;
